import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_check_circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6e742b5c")

_pushScopeId("data-v-6e742b5c")
const _hoisted_1 = {
  id: "history-follow-up-incoming",
  class: "w-full h-full bg-gray-100 overflow-auto pb-16"
}
const _hoisted_2 = { class: "flex items-center gap-x-2" }
const _hoisted_3 = { class: "w-68" }
const _hoisted_4 = { id: "filter-activity-type" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_7 = { class: "bg-gray-lp-1200 p-4 rounded-t-2xl text-gray-lp-300 font-semibold text-sm" }
const _hoisted_8 = { class: "py-4" }
const _hoisted_9 = { class: "flex gap-1 items-center" }
const _hoisted_10 = { class: "flex gap-1 items-center" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_12 = { class: "bg-gray-lp-1200 p-4 rounded-t-2xl text-gray-lp-300 font-semibold text-sm" }
const _hoisted_13 = { class: "flex gap-1 items-center" }
const _hoisted_14 = { class: "font-bold text-base text-black-lp-200" }
const _hoisted_15 = { class: "flex gap-1 items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "check"
}, null, -1)
const _hoisted_17 = { class: "text-base font-bold text-green-lp-100" }
const _hoisted_18 = { class: "text-black-lp-200" }
const _hoisted_19 = { class: "text-gray-lp-800" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_21 = {
  key: 2,
  class: "flex justify-center items-center h-full"
}
const _hoisted_22 = {
  key: 0,
  class: "mb-6 mt-4 bg-white px-4 rounded-xl w-full"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["bg-white p-4 rounded-xl w-full", _ctx.historyFollowUpBooking.length ? '' : 'h-full']
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_TimeRangePicker, {
            id: "filter-date-range-follow-up-history-hanging-incoming",
            placeholder: _ctx.$t('placeholderDatePicker'),
            default: _ctx.$t('custom'),
            startDate: _ctx.filter.startDate,
            endDate: _ctx.filter.endDate,
            onSelect: _ctx.setDateRange,
            class: "w-full",
            maxDate: _ctx.maxDate
          }, null, 8, ["placeholder", "default", "startDate", "endDate", "onSelect", "maxDate"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Select, {
            class: "w-68",
            dataSelect: _ctx.activityType,
            onOpenSelect: () => _ctx.onOpenActivityType(true),
            onCloseSelect: () => _ctx.onOpenActivityType(false),
            onChooseSelect: _ctx.onSelectActivityType,
            value: _ctx.filter.activityType,
            isOpenMenu: _ctx.activityTypeSelect,
            placeholder: _ctx.$t('dashboard.hanging.activityStatus')
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "placeholder"])
        ])
      ]),
      (_ctx.historyFollowUpBooking.length || _ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (index) => {
                    return _createVNode("div", {
                      key: index,
                      class: "w-full border border-gray-lp-1400 rounded-2xl"
                    }, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode(_component_Skeleton)
                      ]),
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (index2) => {
                        return _createVNode("div", {
                          key: index2,
                          class: "px-4"
                        }, [
                          _createVNode("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode(_component_Skeleton)
                            ]),
                            _createVNode("div", _hoisted_10, [
                              _createVNode(_component_Skeleton)
                            ])
                          ])
                        ])
                      }), 64))
                    ])
                  }), 64))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_11, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.historyFollowUpBooking, (data, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "w-full border border-gray-lp-1400 rounded-2xl"
                    }, [
                      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$moment(data.date).format('DD MMM YYYY')), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(data.activities, (detail, index2) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index2,
                          class: "px-4"
                        }, [
                          _createVNode("div", {
                            class: ["py-4", index2 === data.activities.length - 1 ? '' : 'border-b border-gray-lp-1400']
                          }, [
                            _createVNode("div", _hoisted_13, [
                              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.mapActivityType(detail).label), 1),
                              _createVNode("img", {
                                src: require(`@/app/ui/assets/svg/${_ctx.mapActivityType(detail).icon}.svg`),
                                alt: "icon-hanging"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('dashboard.hanging.followUpDone')), 1),
                              _createVNode("div", _hoisted_18, [
                                _createTextVNode("(" + _toDisplayString(detail.username) + ", ", 1),
                                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.formatDateToString(detail.createdAt)), 1),
                                _hoisted_20
                              ])
                            ])
                          ], 2)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
          ]))
        : (_ctx.errorState)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 1,
              class: "h-full",
              errorType: _ctx.errorState
            }, null, 8, ["errorType"]))
          : (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode(_component_EmptyState, {
                icon: "noData_empty",
                customHeaderMessage: _ctx.$t('dashboard.hanging.historyEmptyHeader'),
                customMessage: _ctx.$t('dashboard.hanging.historyEmptyMessage')
              }, null, 8, ["customHeaderMessage", "customMessage"])
            ]))
    ], 2),
    (_ctx.historyFollowUpBooking.length)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          _createVNode(_component_PaginationV3, {
            id: "pagination-history-follow-up-incoming",
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
            onSetPage: _ctx.toPage,
            renderedData: _ctx.renderedData,
            paginationWidth: "w-full"
          }, null, 8, ["pagination", "onSetPage", "renderedData"])
        ]))
      : _createCommentVNode("", true)
  ]))
})